import { post } from '@/core/http';

export const search = async (query: string) => {
  const url = process.env.NEXT_PUBLIC_API_BASE_URL + '/api/rest/private/contacts/search';
  return post({ url, body: JSON.stringify({ name: query }) });
};
